/**
 * Utility functions for managing two-factor authentication state
 */

const TWO_FACTOR_KEY = 'tfa_state';

/**
 * Store 2FA state in sessionStorage
 */
export function setTwoFactorState(twoFactorData, temporaryToken) {
  if (twoFactorData || temporaryToken) {
    sessionStorage.setItem(
      TWO_FACTOR_KEY,
      JSON.stringify({
        twoFactor: twoFactorData,
        temporaryToken: temporaryToken,
      })
    );
  }
}

/**
 * Get 2FA state from sessionStorage
 */
export function getTwoFactorState() {
  const state = sessionStorage.getItem(TWO_FACTOR_KEY);
  if (state) {
    try {
      return JSON.parse(state);
    } catch (e) {
      return null;
    }
  }
  return null;
}

/**
 * Remove 2FA state from sessionStorage
 */
export function removeTwoFactorState() {
  sessionStorage.removeItem(TWO_FACTOR_KEY);
}
